export default function fileAiSvg () {
  return `
    <svg id="file-ai-svg">
      <use xlink:href="/img/icons/file-ai.svg#file-ai-svg" width="160" height="130"></use>
    </svg>
  `
}
